import type { ParentAccessPersistence } from "./LocalParentAccessStore";

const noCleanupNeeded = () => undefined;

export function createBrowserParentAccessPersistence(): ParentAccessPersistence {
  return {
    getItem: (key) => getBrowserLocalStorage().getItem(key),
    setItem: (key, value) => getBrowserLocalStorage().setItem(key, value),
    removeItem: (key) => getBrowserLocalStorage().removeItem(key),
    subscribe: (key, listener) => {
      if (typeof window === "undefined") {
        return noCleanupNeeded;
      }

      const handleStorage = (event: StorageEvent) => {
        if (event.key === null || event.key === key) {
          listener();
        }
      };

      window.addEventListener("storage", handleStorage);
      return () => window.removeEventListener("storage", handleStorage);
    }
  };
}

function getBrowserLocalStorage(): Storage {
  if (typeof window === "undefined") {
    throw new Error("Browser local storage is unavailable.");
  }

  return window.localStorage;
}
